import React, { useState } from 'react';
import { Plus, Mail, MoreVertical, Shield, User, Briefcase, DollarSign } from 'lucide-react';
export function AdminUsersPage() {
  const [showInvite, setShowInvite] = useState(false);
  const users = [{
    id: 1,
    name: 'Alex Morgan',
    email: 'alex@acme.com',
    role: 'Admin',
    dept: 'Operations',
    status: 'Active',
    lastActive: '2 mins ago'
  }, {
    id: 2,
    name: 'Sarah Connor',
    email: 'sarah@acme.com',
    role: 'Manager',
    dept: 'Engineering',
    status: 'Active',
    lastActive: '1 hour ago'
  }, {
    id: 3,
    name: 'John Smith',
    email: 'john@acme.com',
    role: 'Traveler',
    dept: 'Sales',
    status: 'Active',
    lastActive: '3 hours ago'
  }, {
    id: 4,
    name: 'Emily Chen',
    email: 'emily@acme.com',
    role: 'Finance',
    dept: 'Finance',
    status: 'Active',
    lastActive: '1 day ago'
  }, {
    id: 5,
    name: 'Michael Brown',
    email: 'mike@acme.com',
    role: 'Traveler',
    dept: 'Marketing',
    status: 'Pending',
    lastActive: '-'
  }, {
    id: 6,
    name: 'Lisa Wang',
    email: 'lisa@acme.com',
    role: 'Manager',
    dept: 'Sales',
    status: 'Active',
    lastActive: '5 mins ago'
  }, {
    id: 7,
    name: 'David Wilson',
    email: 'david@acme.com',
    role: 'Traveler',
    dept: 'Engineering',
    status: 'Deactivated',
    lastActive: '2 weeks ago'
  }, {
    id: 8,
    name: 'James Bond',
    email: '007@acme.com',
    role: 'Traveler',
    dept: 'Operations',
    status: 'Active',
    lastActive: '2 days ago'
  }];
  const getRoleBadge = (role: string) => {
    switch (role) {
      case 'Admin':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-145">
            <Shield className="w-3 h-3 mr-1" data-id="element-146" /> Admin
          </span>;
      case 'Manager':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-147">
            <Briefcase className="w-3 h-3 mr-1" data-id="element-148" /> Manager
          </span>;
      case 'Finance':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800" data-id="element-149">
            <DollarSign className="w-3 h-3 mr-1" data-id="element-150" /> Finance
          </span>;
      default:
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-151">
            <User className="w-3 h-3 mr-1" data-id="element-152" /> Traveler
          </span>;
    }
  };
  return <div className="space-y-6" data-id="element-153">
      <div className="flex items-center justify-between" data-id="element-154">
        <div data-id="element-155">
          <h2 className="text-2xl font-bold text-slate-800" data-id="element-156">Team Members</h2>
          <p className="text-slate-500" data-id="element-157">
            Manage users, roles, and access permissions.
          </p>
        </div>
        <button onClick={() => setShowInvite(!showInvite)} className="flex items-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700" data-id="element-158">
          <Plus className="mr-2 h-4 w-4" data-id="element-159" />
          Invite User
        </button>
      </div>

      {/* Inline Invite Form */}
      {showInvite && <div className="rounded-xl border border-blue-200 bg-blue-50 p-6 animate-in slide-in-from-top-2" data-id="element-160">
          <h3 className="font-semibold text-blue-900 mb-4" data-id="element-161">
            Invite New Team Member
          </h3>
          <div className="flex gap-4 items-end" data-id="element-162">
            <div className="flex-1" data-id="element-163">
              <label className="block text-xs font-medium text-blue-800 mb-1" data-id="element-164">
                Email Address
              </label>
              <div className="relative" data-id="element-165">
                <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-blue-400" data-id="element-166" />
                <input type="email" className="w-full rounded-lg border-blue-200 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="colleague@company.com" data-id="element-167" />
              </div>
            </div>
            <div className="w-48" data-id="element-168">
              <label className="block text-xs font-medium text-blue-800 mb-1" data-id="element-169">
                Role
              </label>
              <select className="w-full rounded-lg border-blue-200 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-170">
                <option data-id="element-171">Traveler</option>
                <option data-id="element-172">Manager</option>
                <option data-id="element-173">Finance</option>
                <option data-id="element-174">Admin</option>
              </select>
            </div>
            <div className="w-48" data-id="element-175">
              <label className="block text-xs font-medium text-blue-800 mb-1" data-id="element-176">
                Department
              </label>
              <select className="w-full rounded-lg border-blue-200 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-177">
                <option data-id="element-178">Engineering</option>
                <option data-id="element-179">Sales</option>
                <option data-id="element-180">Marketing</option>
                <option data-id="element-181">Operations</option>
              </select>
            </div>
            <button className="bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 font-medium" data-id="element-182">
              Send Invite
            </button>
          </div>
        </div>}

      {/* Users Table */}
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-183">
        <table className="min-w-full divide-y divide-slate-200" data-id="element-184">
          <thead className="bg-slate-50" data-id="element-185">
            <tr data-id="element-186">
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-187">
                User
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-188">
                Role
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-189">
                Department
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-190">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-191">
                Last Active
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-192">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-200" data-id="element-193">
            {users.map(user => <tr key={user.id} className="hover:bg-slate-50" data-id="element-194">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-195">
                  <div className="flex items-center" data-id="element-196">
                    <div className="h-10 w-10 flex-shrink-0 rounded-full bg-slate-200 flex items-center justify-center text-slate-600 font-bold" data-id="element-197">
                      {user.name.charAt(0)}
                    </div>
                    <div className="ml-4" data-id="element-198">
                      <div className="text-sm font-medium text-slate-900" data-id="element-199">
                        {user.name}
                      </div>
                      <div className="text-sm text-slate-500" data-id="element-200">{user.email}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-201">
                  {getRoleBadge(user.role)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500" data-id="element-202">
                  {user.dept}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-203">
                  <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${user.status === 'Active' ? 'bg-emerald-50 text-emerald-700' : user.status === 'Pending' ? 'bg-amber-50 text-amber-700' : 'bg-red-50 text-red-700'}`} data-id="element-204">
                    <span className={`h-1.5 w-1.5 rounded-full ${user.status === 'Active' ? 'bg-emerald-500' : user.status === 'Pending' ? 'bg-amber-500' : 'bg-red-500'}`} data-id="element-205"></span>
                    {user.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500" data-id="element-206">
                  {user.lastActive}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-207">
                  <button className="text-slate-400 hover:text-slate-600" data-id="element-208">
                    <MoreVertical className="h-5 w-5" data-id="element-209" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Pending Invites Section */}
      <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-210">
        <h3 className="font-semibold text-slate-800 mb-4" data-id="element-211">
          Pending Invitations
        </h3>
        <div className="space-y-4" data-id="element-212">
          {[{
          email: 'mike@acme.com',
          role: 'Traveler',
          sent: '2 days ago'
        }, {
          email: 'new.hire@acme.com',
          role: 'Manager',
          sent: '5 hours ago'
        }].map((invite, i) => <div key={i} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg border border-slate-100" data-id="element-213">
              <div className="flex items-center gap-3" data-id="element-214">
                <div className="h-8 w-8 rounded-full bg-amber-100 flex items-center justify-center text-amber-600" data-id="element-215">
                  <Mail className="h-4 w-4" data-id="element-216" />
                </div>
                <div data-id="element-217">
                  <p className="text-sm font-medium text-slate-900" data-id="element-218">
                    {invite.email}
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-219">
                    Invited as {invite.role} • {invite.sent}
                  </p>
                </div>
              </div>
              <div className="flex gap-2" data-id="element-220">
                <button className="text-xs font-medium text-blue-600 hover:text-blue-800" data-id="element-221">
                  Resend
                </button>
                <span className="text-slate-300" data-id="element-222">|</span>
                <button className="text-xs font-medium text-red-600 hover:text-red-800" data-id="element-223">
                  Revoke
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}